$(document).ready(function() {
  $(".shopify-section.index-section .section-slideshow-v1 .slick-slider .slick-list .slick-track .slick-slide .info-sideh1 .picture-slideshow a"
).removeAttr("href");
  $('.tab-pd-details .bd-tab ul.nav.nav-tabs.tab_prod li:nth-child(3) a.underline_scale').on('click', function() {
    $('html, body').animate({
        scrollTop: $('#shopify-section-template--17117051715677__17261903002859e92e').offset().top
    }, 1000);  // Adjust the duration (1000ms = 1 second)
});
  $('.product-item-v9 .product .img-product ul.product-icon-action li:nth-child(1) a').attr('title', 'Out Of Stock').tooltip('dispose').tooltip();
  $('.product-item-v9:hover .product .img-product ul.product-icon-action li:nth-child(1) a').attr('title', 'New Tooltip Title');
});